const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22 22-9.8 22-22c0-1.5-.2-2.6-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.1 29.6 2 24 2 15.6 2 8.3 6.9 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 46c5.5 0 10.5-2.1 14.3-5.6l-6.6-5.6C29.7 36.5 27 37.5 24 37.5c-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C8.2 41 15.5 46 24 46z" />
    <path fill="#1976D2" d="M43.6 20.5H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.4l6.6 5.6C41.9 36.3 46 30.7 46 24c0-1.5-.2-2.6-.4-3.5z" />
  </svg>
);

export default function GoogleButton({ label = "Continuă cu Google", next, testid = "google-login-btn" }) {
  const go = () => {
    if (next) sessionStorage.setItem("ccs_postlogin", next);
    const redirect = `${window.location.origin}/auth/google`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <button
      type="button"
      onClick={go}
      data-testid={testid}
      className="w-full flex items-center justify-center gap-3 border border-line bg-white text-ink px-6 py-3.5 text-sm font-semibold hover:border-ink transition-colors"
    >
      <GoogleIcon />
      {label}
    </button>
  );
}
